import { PipeInformation, PipesVector } from "@imi-ernd-be/hyselect-engine";
import { toArray } from "../vector";

export type Pipe = {
  editable: boolean;
  id: string;
  internalDiameter: number;
  label: string | null;
  maxPressure: number;
  maxTemperature: number;
  roughness: number;
  translationKey: string | null;
  valveSize: string | null;
};

export function buildPipe(pipe: PipeInformation): Pipe {
  return {
    editable: pipe.editable,
    id: pipe.id || "all",
    internalDiameter: pipe.getInternalDiameter()?.valueSI || 0,
    label: pipe.name,
    maxPressure: pipe.getMaxPressure()?.valueSI || 0,
    maxTemperature: pipe.getMaxTemperature()?.valueSI || 0,
    roughness: pipe.getRoughness()?.valueSI || 0,
    translationKey: pipe.translationKey,
    valveSize: pipe.getValveSize(),
  };
}

export function buildPipes(pipes: PipesVector): Pipe[] {
  return toArray(pipes).map(buildPipe);
}
